import { css, LitElement } from 'lit'
import { customElement } from 'lit/decorators/custom-element.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { ApiBlockGridItemModel, ApiBlockItemModel, HtmlTestElementModel } from './api/ContentDeliveryApi.schemas'

@customElement('lindberg-html-test')
export class HtmlTest extends LitElement {
	data: ApiBlockItemModel | ApiBlockGridItemModel

	render() {
		const model = this.data.content as HtmlTestElementModel
		var style = getComputedStyle(this)

		console.log(Object.values(style).filter(x => x.startsWith('--')).toSorted())

		return unsafeHTML(model.properties.content || '')
	}
	static styles = css`
        h1, h2, h3, h4, h5, h6 {
            font-weight: var(--font-weight-light);
            line-height: var(--line-height-header);
        }
        p {
            font-weight: var(--font-weight-light);
            line-height: var(--line-height-body);
        }
    `
}
